<template>
  <div class="container">
    <!-- 页面内容 -->
    <img src="../../assets/goldProductDetail/LOGO.png" class="logo" />
    <div class="report-info">
      <div class="report-info-title">
        <div>权威机构{{ qualityType }}信息</div>
        <img src="../../assets/goldProductDetail/arrow-right-bottom.png" alt="" />
      </div>
      <div class="report-info-line"></div>
      <div class="report-info-content">
        <div class="report-info-content-item">
          <div class="report-info-content-item-title">{{ qualityType }}编号</div>
          <div class="report-info-content-item-value">
            {{ obj.certificateSn }}
          </div>
        </div>
        <div v-if="obj.batchSn" class="report-info-content-item">
          <div class="report-info-content-item-title">批次编号</div>
          <div class="report-info-content-item-value">{{ obj.batchSn }}</div>
        </div>
        <div class="report-info-content-item">
          <div class="report-info-content-item-title">金属名称</div>
          <div class="report-info-content-item-value">{{ obj.metalName }}</div>
        </div>
        <div class="report-info-content-item">
          <div class="report-info-content-item-title">含量</div>
          <div class="report-info-content-item-value">{{ obj.purity }}</div>
        </div>
        <div class="report-info-content-item">
          <div class="report-info-content-item-title">金重</div>
          <div class="report-info-content-item-value">
            {{ obj.metalWeight + "g" }}
          </div>
        </div>
        <div v-if="obj.qualityPerson" class="report-info-content-item">
          <div class="report-info-content-item-title">鉴定师</div>
          <div class="report-info-content-item-value">
            {{ obj.qualityPerson }}
          </div>
        </div>
        <div v-if="obj.qualityOrganization" class="report-info-content-item">
          <div class="report-info-content-item-title">鉴定机构</div>
          <div class="report-info-content-item-value">
            {{ obj.qualityOrganization }}
          </div>
        </div>
        <div class="report-info-content-item" v-if="obj.certificateUrl">
          <div class="report-info-content-item-title">机构网站</div>
          <div class="report-info-content-item-value certificateUrl" :class="{
            'is-collapsed': !showFullCertificateUrl,
            expanded: showFullCertificateUrl,
          }">
            <span class="certificate-url-text">{{ obj.certificateUrl }}</span>
            <span class="certificate-url-toggle" v-if="shouldShowExpand" @click.stop="toggleCertificateUrl">{{
              showFullCertificateUrl ? "收起" : "展开" }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="seeReportBtn" @click="toReportDetail">查看{{ qualityType }}详情</div>
    <div class="recycling" @click="showPopup"></div>
    <div class="company-product-tab">
      <div class="company-product-tab-item" @click="toIntroduction">
        企业介绍
      </div>
      <div class="company-product-tab-line"></div>
      <div class="company-product-tab-item" @click="toAdvantage">产品优势</div>
    </div>
    <div class="product-info">
      <div class="product-info-title">
        <div>商品信息及溯源</div>
        <img src="../../assets/goldProductDetail/arrow-right-bottom.png" alt="" />
      </div>
      <div class="product-info-line"></div>
      <div class="product-info-swiper">
        <van-swipe class="my-swipe" :autoplay="30000" @change="onChange">
          <van-swipe-item v-for="item in obj.imgList" :key="item">
            <img :src="item" alt="" style="width: 100%; height: 100%" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="product-info-name">
        {{ obj.productName }}
      </div>
      <div class="product-info-gold">
        <div class="product-info-gold-title">{{ obj.metalName }}</div>
        <div class="product-info-gold-value">{{ obj.purity }}</div>
        <div class="product-info-gold-value">{{ obj.metalWeight }}g</div>
      </div>
      <div class="product-info-code">
        <div>监管码:</div>
        <div>{{ obj.barCode }}</div>
      </div>
      <div class="product-info-code">
        <div>金条编码:</div>
        <div>{{ obj.thirdUniqueCode }}</div>
      </div>
      <div class="product-info-retrospect">
        <div class="product-info-retrospect-title">为您溯源财富历程</div>
        <div class="product-info-retrospect-content">
          <div class="product-info-retrospect-content-item" v-if="saleInfo">
            <div class="product-info-retrospect-content-item-top">
              <div>
                {{ saleInfo.actionType }}
              </div>
              <div style="color: #999999">
                {{ saleInfo.doneTime }}
              </div>
            </div>
          </div>
          <div class="product-info-retrospect-content-item" v-if="qualityCheckInfo">
            <div class="product-info-retrospect-content-item-top">
              <div>{{ qualityCheckInfo.actionType }}</div>
              <div style="color: #999999">{{ qualityCheckInfo.doneTime }}</div>
            </div>
            <div>
              <span style="font-size: 28px; color: #999999">质检机构: </span>
              <span style="font-size: 28px">{{
                qualityCheckInfo.orgName
              }}</span>
            </div>
          </div>
          <div class="product-info-retrospect-content-item">
            <div class="product-info-retrospect-content-item-top">
              <div>{{ ProductionInfo.actionType }}</div>
              <div style="color: #999999">{{ ProductionInfo.doneTime }}</div>
            </div>
            <div>
              <span style="font-size: 28px; color: #999999">生产厂家:</span>{{ ProductionInfo.orgName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="introduction" ref="introduction">
      <img src="../../assets/goldProductDetail/introduction.png" alt="" />
      <div style="margin-top: 32px; margin-bottom: 24px">
        深圳样版师制造有限公司(简称样版师)于2019年3月成
        立，是正金产业集团旗下的子公司，作为正金集团在珠
        宝供应链领域的重要一员，样版师专注于黄金珠宝行业
        全产业链的科技和数字化发展。
      </div>
      <div>
        公司凭借国有资本参股的强大资金和资源整合能力，在
        产业园级加工制造、研发设计、数字科技、智能供应链
        、品牌孵化、批发零售等方面展现出显著实力。样版师
        建立了以精品黄金为特色的产品线，涵盖足金999、足
        金9999、古法黄金、3D/5D硬足金、黄金镶嵌、投资
        金条等，并提供数字科技和原创设计的一站式服务体
        系，为全球珠宝品牌商提供高效、安全、快捷的数字化 珠宝产品和服务。
      </div>
    </div>
    <div class="line"></div>
    <div id="advantage" ref="advantage">
      <img src="../../assets/goldProductDetail/advantage.png" alt="" />
      <img src="../../assets/goldProductDetail/advantage_desc.png" alt="" />
    </div>
    <div class="line"></div>
    <div class="footer">
      <div class="footer-item">
        <div class="footer-item-left">
          <div>
            <img src="../../assets/goldProductDetail/phone.png" alt="" />
            <span>客服电话</span>
          </div>
          <div>
            <div>180 9890 2754</div>
            <div>198 2081 3304</div>
          </div>
        </div>

        <div class="footer-item-right">
          <img src="../../assets/goldProductDetail/account_qrcode.png" alt="" />
        </div>
      </div>
      <div class="footer-item">
        <div class="footer-item-left">
          <div>
            <img src="../../assets/goldProductDetail/location.png" alt="" />
            <span>展厅位置</span>
          </div>
          <div>
            <div>特力珠宝大厦A座3楼3A02-1</div>
            <div>负一层M区L1-039</div>
          </div>
        </div>

        <div class="footer-item-right">
          <img src="../../assets/goldProductDetail/app_qrcode.png" alt="" />
        </div>
      </div>
    </div>
    <div class="floatWindowbox">
      <div class="floatWindowbox-top" @click="showPopup">
        <div class="floatWindowbox-top-recyclingLogo"></div>
        <div class="floatWindowbox-top-tip">回收</div>
      </div>
      <div class="floatWindowbox-bottom" @click="backTop">
        <img src="../../assets/goldProductDetail/up.png" alt="" />
      </div>
    </div>

    <van-popup v-model="show">
      <img src="../../assets/goldProductDetail/recyleContent.png" alt=""
        style="width: 90vw; height: auto; object-fit: cover" />
      <div style="text-align: center; margin-top: 8px" @click="show = false">
        <van-icon class="close-icon" name="close" color="#fff" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getProductDetail, canRent } from "@/api/product.js";
import { getlifeLogOut } from "@/api/sourceInfo";
import { ImagePreview } from "vant";
export default {
  computed: {
    barCode() {
      return this.$route.params.barCode;
    },
    saleInfo() {
      const list =
        this.obj && Array.isArray(this.obj.sourceInfoList)
          ? this.obj.sourceInfoList
          : [];
      return list.find((_) => _.actionType === "销售") || null;
    },
    qualityType() {
      return this.obj.qualityType === 'REPORT' ? '报告' : '证书';
    },
    qualityCheckInfo() {
      const list =
        this.obj && Array.isArray(this.obj.sourceInfoList)
          ? this.obj.sourceInfoList
          : [];
      return list.find((_) => _.actionType === "质检") || null;
    },
    ProductionInfo() {
      const list =
        this.obj && Array.isArray(this.obj.sourceInfoList)
          ? this.obj.sourceInfoList
          : [];
      return list.find((_) => _.actionType === "生产") || {};
    },
    shouldShowExpand() {
      // 根据长度来决定是否显示展开按钮，可根据实际需要调整阈值
      return (this.obj.certificateUrl || "").length > 10; // 32 字符阈值
    },
  },
  created() {
    this.getData();
  },
  data() {
    return {
      show: false,
      obj: {
        productName: "",
        imgList: [],
        metalName: "",
        purity: "",
        weight: "",
        barCode: "",
        thirdUniqueCode: "",
        sourceInfoList: [],
        certificateSn: null,
        certificateUrl: "",
        qualityOrganization: "",
        qualityPerson: null,
        metalWeight: "",
      },
      current: 0,
      showFullCertificateUrl: false,
      // 数据属性
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    toRecyle() {
      window.open("http://192.168.110.45:80/recyle");
      // console.log(process.env, "env");
      // this.$router.push({ path: "/g/recyle" });
    },
    toggleCertificateUrl() {
      this.showFullCertificateUrl = !this.showFullCertificateUrl;
    },
    toReportDetail() {
      const { certificateType, certificateFrontUrl, certificateBackUrl } = this.obj;
      if (certificateType === 1) {
        ImagePreview({
          images: [certificateFrontUrl, certificateBackUrl].filter(url => url),
          closeOnPopstate: true,
          showIndex: false,
        });
      } else {
        //打开外部链接
        window.open(this.obj.certificateUrl);
      }
    },
    backTop() {
      // 平滑回到顶部：统一处理 iOS / Android，避免未定义 isAndroid 报错
      const ua = navigator.userAgent;
      const isiOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua);
      // 兼容性获取可滚动元素
      const scrollEl =
        document.scrollingElement ||
        (isiOS ? document.documentElement : document.body) ||
        document.documentElement;
      const start = scrollEl.scrollTop;
      const duration = 300; // 动画时长 ms
      const startTime = Date.now();
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      function step() {
        const now = Date.now();
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = easeOutCubic(progress);
        scrollEl.scrollTop = start * (1 - eased);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    },
    async getData() {
      const {
        data: { data },
      } = await getProductDetail({ barCode: this.barCode });
      const {
        data: {
          data: { list },
        },
      } = await getlifeLogOut({ barCode: this.barCode });
      const obj = {};
      const { batchSn, qualityWeight, precious, qualityType, certificateType, certificateFrontUrl, certificateBackUrl } = data.wmsProductSnQualityCertificateVO || {};
      obj.imgList = this.handleImgList(data.wmsProductVO);
      obj.productName =
        data.wmsProductVO.allName.productDisplayName ||
        data.wmsProductVO.allName.productName;
      obj.metalName = data.wmsProductVO.allName.metalName;
      obj.purity = precious || data.wmsProductVO.purity;
      obj.barCode = data.wmsCodeVO.barCode;
      obj.metalWeight = qualityWeight || data.wmsCodeVO.metalWeight;
      obj.certificateSn = data.wmsProductSnQualityCertificateVO
        ? data.wmsProductSnQualityCertificateVO.certificateSn
        : null;
      obj.thirdUniqueCode = data.wmsCodeVO.thirdUniqueCode;
      obj.sourceInfoList = list || [];
      obj.certificateUrl = data.wmsProductSnQualityCertificateVO
        ? data.wmsProductSnQualityCertificateVO.certificateUrl
        : null;
      obj.qualityOrganization = data.wmsProductSnQualityCertificateVO
        ? data.wmsProductSnQualityCertificateVO.qualityOrganization
        : null;
      obj.qualityPerson = data.wmsProductSnQualityCertificateVO
        ? data.wmsProductSnQualityCertificateVO.qualityPerson
        : null;

      // Object.assign(this.obj, obj);
      this.obj = { ...this.obj, ...obj, batchSn, qualityType, certificateType, certificateFrontUrl, certificateBackUrl }
    },
    handleImgList(value) {
      const imgKeys = ["imgDownView", "imgLeftView", "imgRightView"];
      return Object.keys(value)
        .filter((_) => {
          return imgKeys.includes(_) && value[_];
        })
        .map((_) => value[_]);
    },
    toIntroduction() {
      this.$refs.introduction.scrollIntoView({ behavior: "smooth" });
    },
    toAdvantage() {
      this.$refs.advantage.scrollIntoView({ behavior: "smooth" });
    },
    onChange(index) {
      this.current = index;
    },
    // 方法
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-popup {
  background: rgba(0, 0, 0, 0) !important;
}

.close-icon {
  text-align: center;
  margin: 0 auto;
  font-size: 64px;
}

.certificateUrl {
  position: relative;
  display: inline-block;
  max-width: 100%;
  line-height: 1.4;
  word-break: break-all;
  padding-right: 72px; // 为按钮留空间

  .certificate-url-text {
    display: inline;
  }

  &.is-collapsed {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
  }

  &.expanded {
    white-space: normal;
  }

  .certificate-url-toggle {
    position: absolute;
    top: 0;
    right: 0;
    padding-left: 8px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 30%);
    color: #f08519;
    font-size: 24px;
    cursor: pointer;
  }
}

.floatWindowbox {
  position: fixed;
  right: 0;
  top: 50%;
  width: 88px;
  height: 156px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &-bottom {
    width: 88px;
    height: 44px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e2e4ea;
    display: flex;
    justify-content: center;
    align-items: center;

    >img {
      width: 32px;
      height: 32px;
      margin: 6px auto;
    }
  }

  &-top {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 88px;
    height: 88px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e2e4ea;
    padding: 8px 0;

    &-recyclingLogo {
      width: 32px;
      height: 32px;
      background: url("../../assets/goldProductDetail/recycling_float.png") no-repeat center;
      background-size: cover;
    }

    &-tip {
      width: 49px;
      height: 33px;
      font-weight: 400;
      font-size: 24px;
      color: #f08519;
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 100%;
  padding: 48px 32px;

  .footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;

    &-item {
      width: 100%;
      display: flex;
      justify-content: space-between;

      &-left {
        flex: 1;

        div:nth-child(1) {
          display: flex;
          gap: 4px;
          align-items: center;

          >img {
            width: 48px;
            height: 48px;
          }
        }

        div:nth-child(2) {
          font-weight: 600;
          font-size: 32px;
          color: #333333;
        }
      }

      &-right {
        width: 140px;
        height: 158px;

        >img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  #advantage {
    display: flex;
    flex-direction: column;
    gap: 24px;

    >img:nth-child(1) {
      width: 100%;
      height: 673px;
    }

    >img:nth-child(2) {
      width: 100%;
      height: 551px;
    }
  }

  #introduction {
    >img {
      width: 100%;
      height: 673px;
    }
  }

  .product-info {
    &-retrospect {
      width: 100%;
      max-height: 453px;
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      gap: 24px;

      &-content {
        background: #f6f5f0;
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 24px;
        justify-content: space-between;
        border-radius: 16px;
        gap: 24px;

        &-item {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-bottom: 16px;
          border-bottom: 1px dashed #e2e4ea;

          &:last-child {
            padding-bottom: 0;
            border-bottom: none;
          }

          &-top {
            display: flex;
            gap: 8px;

            >div:nth-child(1) {
              width: 56px;
              font-weight: 400;
              font-size: 28px;
              color: #f08519;
            }
          }
        }
      }

      &-title {
        width: 264px;
        height: 45px;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
      }
    }

    &-code {
      display: flex;
      gap: 8px;
      font-size: 28px;
      margin-top: 24px;

      >div:nth-child(1) {
        color: #666666;
      }

      >div:nth-child(2) {
        color: #333333;
      }
    }

    &-gold {
      display: flex;
      color: #f08519;
      font-size: 28px;
      font-weight: 500;

      >div:not(:last-child)::after {
        content: "|";
        margin: 0 8px;
      }
    }

    width: 100%;

    &-name {
      width: 100%;
      height: 45px;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 45px;
      text-align: left;
      margin: 16px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &-swiper {
      width: 100%;
      height: 915px;
    }

    &-line {
      width: 100%;
      height: 1px;
      background: #707070;
      margin: 8px 0 24px 0;
    }

    &-title {
      width: 100%;
      display: flex;
      justify-content: space-between;

      >div:nth-child(1) {
        width: 256px;
        height: 45px;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
        line-height: 45px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      >img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .company-product-tab {
    width: 100%;
    height: 61px;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #f08519;
    display: flex;
    justify-content: space-around;
    align-items: center;

    &-line {
      width: 1px;
      height: 45px;
      background: #f08519;
      border-radius: 0px 0px 0px 0px;
    }

    &-item {
      width: 128px;
      height: 45px;

      font-weight: 500;
      font-size: 32px;
      color: #f08519;
      line-height: 45px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .logo {
    display: block;
    width: 412px;
    height: 164px;
    margin: 0 auto;
  }

  .seeReportBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 360px;
    height: 88px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #f08519;

    font-weight: 500;
    font-size: 32px;
    color: #f08519;
  }

  .recycling {
    position: relative;
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    height: 180px;
    background: url("../../assets/goldProductDetail/Recycling.png") no-repeat center;
    background-size: cover;
  }

  .report-info {
    width: 100%;

    // height: 542px;
    &-content {
      display: flex;
      flex-direction: column;
      gap: 24px;

      &-item {
        display: flex;
        justify-content: space-between;

        &-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #666666;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        &-value {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          line-height: 39px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          max-width: 50%;
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    &-line {
      width: 100%;
      height: 1px;
      background: #707070;
      margin: 8px 0 24px 0;
    }

    &-title {
      width: 100%;
      display: flex;
      justify-content: space-between;

      >div:nth-child(1) {
        width: 256px;
        height: 45px;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
        line-height: 45px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      >img {
        width: 40px;
        height: 40px;
      }
    }
  }
}

::v-deep .van-swipe__indicator--active {
  width: 32px !important;
  height: 8px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 8px 8px 8px 8px;
}

::v-deep .van-swipe__indicator {
  width: 16px;
  height: 8px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 8px 8px 8px 8px;
}

.van-swipe {
  height: 100%;
}

.my-swipe .van-swipe-item {
  height: 100%;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.line {
  width: 100%;
  height: 1px;
  background: #707070;
}
</style>
